export enum SiteStatus {
    Enabled = 1,
    Disabled = 2
}